/**
 * Split a spelling sentence around its misspelled word so the word can be
 * replaced with an inline gap input. Whole-word match (no lookbehind, for
 * older-browser safety); returns null when the word isn't found, in which
 * case the caller falls back to sentence + separate input.
 */
export const splitSentenceAtWord = (
  sentence: string,
  word: string
): { before: string; after: string } | null => {
  if (!sentence || !word) return null;
  const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const m = new RegExp(`(^|[^A-Za-z’'-])(${escaped})(?![A-Za-z’'-])`).exec(sentence);
  if (!m) return null;
  const start = m.index + m[1].length;
  return { before: sentence.slice(0, start), after: sentence.slice(start + word.length) };
};
